/**
 * Single source for everything that states who we are: legal pages, imprint,
 * footer, sitemap, mailto links. Values marked TODO_ must be filled by the
 * owner before launch — they render visibly on purpose so they cannot be
 * forgotten.
 */
export const COMPANY = {
  brand: "Coldfire",
  product: "Coldfire CRM",
  legalName: "TE Software Solutions LLC",
  street: "St. Petersburg str. N 1",
  city: "Tbilisi",
  country: { en: "Georgia", de: "Georgien" },
  registerNumber: "TODO_REGISTER_NUMBER",
  vatId: "TODO_VAT_ID",
  director: "TODO_MANAGING_DIRECTOR",
  emails: {
    legal: "legal@coldfire-crm.com",
    billing: "billing@coldfire-crm.com",
    support: "support@coldfire-crm.com",
    privacy: "privacy@coldfire-crm.com",
  },
  siteUrl: "https://coldfire-crm.com",
  appUrl: "https://app.coldfire-crm.com",
  apiDocsPath: "/docs/api",
} as const;

export type LegalLocale = "en" | "de";

/** One date for all legal pages; bump when any of them changes. */
export const LEGAL_UPDATED = { en: "September 21, 2026", de: "21. September 2026" } as const;

export const companyAddressLine = (locale: LegalLocale): string =>
  `${COMPANY.legalName}, ${COMPANY.street}, ${locale === "de" ? "Tiflis" : COMPANY.city}, ${COMPANY.country[locale]}`;

/** Canonical site origin: env override for previews, else the production domain. */
export const siteUrl = (): string =>
  (process.env.NEXT_PUBLIC_SITE_URL || COMPANY.siteUrl).replace(/\/$/, "");
